import { Box } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";

export default function TenantUser() {
    return <>
        <Box>
            <BAScreenHeader title='Tanent User' />
        </Box>
    </>
}